module.exports = __webpack_public_path__ + "static/media/logomedicall24horizontal.a6759d9d.svg";